import { api } from '@/store/interfaces/apiCraft'
import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    entry: {},
    loaded: false
  },

  getters: {
    entry: state => {
      return state.entry
    },
    objects: state => {
      return state.entry.avObject ? state.entry.avObject : []
    },
    loaded: state => {
      return state.loaded
    },
  },

  actions: {
    entry ({ commit, state }, slug) {
      const { request, cache } = api.getEntry(slug)
      // cache.then(res => {
      //   if (res !== null) {
      //     commit('entry', res)
      //     commit('loaded', true)
      //   }
      // })

      request.then(res => {
        commit('entry', res)
        commit('loaded', true)
      })
    },
  },

  mutations: {
    loaded (state, payload) {
      state.loaded = payload
    },
    entry (state, payload) {
      state.entry = payload

      state.entry.avObject.forEach(object => {
        // TIME APPEARANCE
        let time = object.timeAppearance.split(':')
        if (time.length !== 2) {
          object.timeAppearance = ''
        }
        else {
          object.timeAppearance = parseFloat(time[0]) * 60 + parseFloat(time[1])
        }
        // TIME DISAPPEARANCE
        time = object.timeDisappearance.split(':')
        if (time.length !== 2) {
          object.timeDisappearance = ''
        }
        else {
          object.timeDisappearance = parseFloat(time[0]) * 60 + parseFloat(time[1])
        }
      })
    }
  }
}